import React from "react";
import ReactDOM from "react-dom";

export default class SlideContainer extends React.Component {
    componentDidMount(){
        if(this.props.child){
            this._root.appendChild(this.props.child);
        }
    }

    render() {
        return (
            <div ref={(c) => this._root = c} className='pubhub-slide-container'></div>
        )
    }
}